export default "__VITE_ASSET__GmMLP9oV__"